import { FormAPI } from '@brg/api';
import { useEffect, useState } from 'react';
export var useForm = function (ids) {
    var _a = useState(), forms = _a[0], setForms = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var fetchForms = function (ids) {
        setIsLoading(true);
        setError(null);
        //@ts-ignore
        FormAPI.Get({
            idForm: ids,
        })
            .then(function (r) {
            if (!r.ok) {
                throw new Error("Error: ".concat(r.status, " ").concat(r.statusText));
            }
            return r.json();
        })
            //@ts-ignore
            .then(function (r) {
            setIsLoading(false);
            setForms(r);
        })
            .catch(function (err) {
            setIsLoading(false);
            setError(err.message);
        });
    };
    useEffect(function () {
        if (!!(ids === null || ids === void 0 ? void 0 : ids.length)) {
            fetchForms(ids);
        }
    }, [ids]);
    return [forms, isLoading, error];
};
//# sourceMappingURL=useForm.js.mapimport { FormAPI } from '@brg/api';
import { useEffect, useState } from 'react';
export var useForm = function (ids) {
    var _a = useState(), forms = _a[0], setForms = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var fetchForms = function (ids) {
        setIsLoading(true);
        setError(null);
        //@ts-ignore
        FormAPI.Get({
            idForm: ids,
        })
            .then(function (r) {
            if (!r.ok) {
                throw new Error("Error: ".concat(r.status, " ").concat(r.statusText));
            }
            return r.json();
        })
            //@ts-ignore
            .then(function (r) {
            setIsLoading(false);
            setForms(r);
        })
            .catch(function (err) {
            setIsLoading(false);
            setError(err.message);
        });
    };
    useEffect(function () {
        if (!!(ids === null || ids === void 0 ? void 0 : ids.length)) {
            fetchForms(ids);
        }
    }, [ids]);
    return [forms, isLoading, error];
};
//# sourceMappingURL=useForm.js.map